// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3SpfZ","row":"Node_row__qrcuZ","label":"Node_label__24uvp","footer":"Node_footer__2kie9"};